import { format } from '@react-input/mask';

function getMask(digitsQuantity = 0) {
  const mask8Digits = '(__) ____-_____';
  const mask9Digits = '(__) _____-____';

  const maxFormattedPhoneDigits = 11;

  const isNineDigits = digitsQuantity >= maxFormattedPhoneDigits;

  return isNineDigits ? mask9Digits : mask8Digits;
}

export function formatPhone(phone = '') {
  const replacement = { _: /\d/ };

  const cleanedPhone = phone.replace(/\D/g, '');

  const mask = getMask(cleanedPhone.length);

  return format(cleanedPhone, { mask, replacement });
}
